import { Menu, MenuItem } from "@mui/material";
import { ImagePlus, PencilIcon } from "lucide-react";

const ProfileMiniDropDown = ({
  anchorEl,
  onClose,
  hasImage,
  onAdd,
  onUpdate,
  onRemove,
}) => {
  const open = Boolean(anchorEl);

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      {/* <MenuItem onClick={onUpdate}
      
      > */}
      <MenuItem
        onClick={() => {
          onUpdate();
          onClose(); // close after update
        }}
        className="gap-2"
      >
        <PencilIcon size={18} />
        Change profile image
      </MenuItem>

      {/* <MenuItem onClick={onRemove}> */}
      <MenuItem
        onClick={() => {
          onRemove();
          onClose(); // close after remove
        }}
        className="gap-2"
      >
        {/* <ImageMinus /> */}
        <ImagePlus size={18} />
        Remove profile image
      </MenuItem>
    </Menu>
  );
};

export default ProfileMiniDropDown;
